__turbopack_context__.v({
  "arrowButton": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__arrowButton",
  "chip": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__chip",
  "chip-spin": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__chip-spin",
  "chipActive": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__chipActive",
  "chipPending": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__chipPending",
  "chipSpinner": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__chipSpinner",
  "chipTrack": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__chipTrack",
  "gradient": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__gradient",
  "scrollContainer": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__scrollContainer",
  "selector": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__selector",
  "wrapper": "ProductUpdatesMonthSelector-module-scss-module__Kh7JKW__wrapper",
});
